export default "__VITE_ASSET__CcaW$7Gt__"